angular.module("vgresiduos").controller("PropertiesEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			if ($stateParams.id) {
				Vgr.util.redirectSingleton($rootScope, `organizacao/propriedades/${$stateParams.id}`);
			} else {
				Vgr.util.redirectSingleton($rootScope, `organizacao/propriedades`);
			}
		};
	}
]);
